import React,{useState,useEffect} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHouse,faCode,faMusic,faSchool,faPodcast,faFilm,faGamepad,faTv,faBaseball,faShirt,faMasksTheater,faDumbbell, faBitcoinSign} from '@fortawesome/free-solid-svg-icons'
import { fetchDetails } from './getDetails';
import Video from './video';
import '../style.css';

function getWindowSize() {
  const {innerWidth, innerHeight} = window;
  return {innerWidth, innerHeight};
}

function Feed(props) {
  const categories = [
    { name: 'New', icon: faHouse, },
    { name: 'Coding', icon: faCode },
    { name: 'ReactJS', icon: faCode },
    { name: 'NextJS', icon: faCode },
    { name: 'Music', icon: faMusic },
    { name: 'Education', icon: faSchool, },
    { name: 'Podcast', icon: faPodcast },
    { name: 'Movie', icon: faFilm },
    { name: 'Gaming', icon: faGamepad },
    { name: 'Live', icon:  faTv},
    { name: 'Sport', icon:  faBaseball},
    { name: 'Fashion', icon:  faShirt},
    { name: 'Comedy', icon:faMasksTheater},
    { name: 'Gym', icon:  faDumbbell},
    { name: 'Crypto', icon: faBitcoinSign },
  ];


  const [selectedCategory,setSelectedCategory] = useState('New');
  const [videos,setVideos] = useState([]);
  const handleClick = (e)=>{
    setSelectedCategory(e.target.innerText);
  }
  useEffect(() => {
    const getDetails = async()=>{
      const details = await fetchDetails(`search?part=snippet&q=${selectedCategory}`);
      setVideos(details.items);
    }
    getDetails();

  }, [selectedCategory])



  
  const [windowSize, setWindowSize] = useState(getWindowSize());

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    props.updateToShow();
    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);
  
  
  return (
    <div className='flex gap-5 bg-[#202020] pt-16 md:pt-20 items-center ' >
      <div className="sidebar  w-[15rem] space-y-3 bg-[#202020] min-w-fit  mr-10 px-5  sm:overflow-y-auto h-[45rem] fixed  top-12 md:visible  " style={{visibility:windowSize.innerWidth<640?(props.showSidebar? 'visible':'hidden'):'visible'}}>
        {
          categories.map((category,index) => (
            <div 
            className="sidebar__category flex space-x-2 text-white text-left hover:bg-red-700 hover:text-black rounded-md py-1 px-1 md:py-4 md:px-6 items-center  " 
            key={index}
            onClick={handleClick}
            >
              <FontAwesomeIcon className="text-red-600 hover:text-black" icon={category.icon} />
              <p className='font-medium'>{category.name}</p>
            </div>
          ))}
        
      </div>
      <div className="feed  sm:ml-[16rem]   flex sm:justify-start  flex-col   w-full">
          {/* <hr className='bg-white'/> */}
        <div className="heading">
            <p className='text-white text-center sm:text-left font-bold text-xl md:text-3xl'>{selectedCategory} <span className='text-red-600'> Videos</span> </p>
        </div>
        <div className="feed__videos ">
          <Video videos={videos} className=""/>
          </div>
        </div>
    </div>
  )
}

export default Feed